import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx'
import { StateProvider } from "./GlobalState/StateProvider";
import appReducer, { initialState } from "./GlobalState/appReducer";
import { PrimeReactProvider } from "primereact/api";
import './index.css'

//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');



ReactDOM.createRoot(document.getElementById('root')).render(
  /*  <React.StrictMode>*/
        <StateProvider initialState={initialState} reducer={appReducer}>
            <BrowserRouter >
                <PrimeReactProvider value={{ unstyled: false, pt: {} }}>
                    <App />
                </PrimeReactProvider>
            </BrowserRouter>

        </StateProvider>
   /* </React.StrictMode>,*/
)
